import adminApi from "../../api";
import publicApi from "../../publicApi";

class SettingsService {
  async getPhoneNumber() {
    const response = await publicApi.get("/settings/phone-number");
    return response.data;
  }

  async getContacts() {
    const response = await publicApi.get("/settings/contacts");
    return response.data;
  }

  async getOrderStatus() {
    const response = await publicApi.get("/settings/order-status");
    return response.data; // { accepting: boolean, reason: string|null }
  }

  async updatePhoneNumber(phoneNumber) {
    const response = await adminApi.put("/settings/phone-number", {
      phoneNumber,
    });
    return response.data;
  }

  async updateContacts(payload) {
    const response = await adminApi.put("/settings/contacts", payload);
    return response.data;
  }

  async updateOrderStatus(payload) {
    const response = await adminApi.put("/settings/order-status", payload);
    return response.data;
  }
}

export default new SettingsService();
